export default __webpack_public_path__ + "static/media/seating.1a450de7.svg";